import Contact from "../../Pages/Home/Contact/Contact";
import Gallery from "../../Pages/Home/Gallery/Gallery";
import Home from "../../Pages/Home/Home/Home";
import AboutInfo from "../../Pages/Home/MoreAboutUsInfo/AboutInfo";
import Login from "../../Pages/Login/Login";
import SignUp from "../../Pages/SignUp/SignUp";

const { createBrowserRouter } = require("react-router-dom");
const { default: Main } = require("../../Layout/Main");

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      /* {
        path: "/login",
        element: <Login />,
      }, */
      {
        path: "/signup",
        element: <SignUp />,
      },
      {
        path: "/aboutinfo",
        element: <AboutInfo />,
      },
      {
        path: "/gallery",
        element: <Gallery />
      },
      {
        path: "/contact",
        element: <Contact/>
      }
    ],
  },
]);

export default router;
